
import './styles.css';
import InsaneTable from '../../component/insane-table';

function MaintenanceResultMTView(props)  {
    const PARAM = props.location.state;
    // console.log(PARAM);
    
    const tableOption = {
        tableName: "WorkOrder View",
        className: "",
        search: [
            {
                reqName: "mtresultno",
                displayName: "MT Result No",
                element: "input",
                placeholder: "Enter MT Result No."
            },
            {
                reqName: "status_approve",
                displayName: "Status Approve",
                element: "select",
                placeholder: "Select Status Approve.",
                option: []
            }
        ],
        mapTable: [
            {
                displayName: "MT Result No",
                attName: "mtresultno",
                type: "text",
                form: {
                    validate: true,
                    element: "input"
                }
            },
            {
                displayName: "Work order No",
                attName: "workorderno",
                type: "text",
                form: {
                    validate: true,
                    element: "input"
                }
            },
            {
                displayName: "Formcode",
                attName: "formcode",
                type: "text",
                form: {
                    validate: true,
                    element: "input"
                }
            },
            {
                displayName: "Logtime",
                attName: "logtime",
                type: "date",
                form: {
                    validate: true,
                    element: "input"
                }
            },
            {
                displayName: "Calibration Date",
                attName: "calibration_date",
                type: "date",
                form: {
                    validate: true,
                    element: "input"
                }
            },
            {
                displayName: "Note",
                attName: "note",
                type: "text",
                form: {
                    validate: true,
                    element: "input"
                }
            },
            {
                displayName: "Status Workorder",
                attName: "status_workorder",
                type: "text",
                form: {
                    validate: true,
                    element: "input"
                }
            },
            {
                displayName: "Status Tolerance",
                attName: "status_tolerance",
                type: "text",
                form: {
                    validate: true,
                    element: "input"
                }
            },
            {
                displayName: "Status Accept Workorder",
                attName: "status_accept_workorder",
                type: "text",
                form: {
                    validate: true,
                    element: "input"
                }
            },
            {
                displayName: "Concern Person",
                attName: "concern_person",
                type: "text",
                form: {
                    validate: true,
                    element: "input"
                }
            },
            {
                displayName: "Status Approve",
                attName: "status_approve",
                type: "text",
                form: {
                    validate: true,
                    element: "input"
                }
            },
            {
                displayName: "Approve Remark",
                attName: "approve_remark",
                type: "text",
                form: {
                    validate: true,
                    element: "input"
                }
            }
        ],
        api: {
            view: {
                enable: true,
                url: "/admin/mt/mtresult/get",
                dataReq: {
                    "index": 0,
                    "count": 10,
                    "mtresultno": "",
                    "workorderno": PARAM.workorderno,
                    "status_approve":"",
                    "approve_remark":""
                }
            },
            insert: {
                enable: false,
                url: "/admin/mt/mtresult/update",
                dataReq: {}
            },
            update: {
                enable: false,
                url: "/admin/mt/mtresult/update",
                dataReq: {}
            },
            delete: {
                enable: false,
                url: "/admin/mt/mtresult/delete",
                dataReq: {}
            }
        },
        action: [
            // {
            //     name: "MT Result",
            //     mode: "page", /// page, modal, form
            //     option: {
            //         url: "/d-rec-admin/main/maintenance/result-mt/view"
            //     }
            // }
        ]
    }

    return (
        <div className='content'>

            <div className='content-page'>
                <div className='head-content-page'>{PARAM.equipment_tagid}</div>
                <div className='head-content-page-sub'>Work Order No : {PARAM.workorderno}</div>
                <InsaneTable option={tableOption}></InsaneTable>
            </div>

        </div >);
}

export default MaintenanceResultMTView;